import { ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material"
import { Image } from "components/Image"
import { DEFAULT_VENUE_FILTER } from "constant"
import { useTranslation } from "providers/i18n"
import { useVenue } from "providers/venue"
import { useCallback, useMemo } from "react"
import { getFeatureDetail } from "utils/feature"

export const VenueFilterBar = ({ onClickVenue, value }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { venues = [] } = useVenue()
  const { root, button, logoImage } =
    theme.components[`VenueFilterBar`]?.styleOverrides || {}
  const handleClick = useCallback(
    (venueId) => () => {
      onClickVenue(venueId)
    },
    [onClickVenue]
  )
  const venueInfos = useMemo(() => {
    return venues.map(getFeatureDetail)
  }, [venues])

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      aria-label="venue filter"
      sx={root}
    >
      <ToggleButton
        value={DEFAULT_VENUE_FILTER}
        sx={button}
        key={`venue-filter-${DEFAULT_VENUE_FILTER}`}
        className={DEFAULT_VENUE_FILTER}
        onClick={handleClick(DEFAULT_VENUE_FILTER)}
      >
        {t("All Mall")}
      </ToggleButton>
      {venueInfos.map(({ id, name, logo, reference }) => {
        return (
          <ToggleButton
            value={id}
            sx={button}
            key={`venue-filter-${id}`}
            className={reference}
            onClick={handleClick(id)}
          >
            {logo ? <Image src={logo} sx={logoImage} /> : t(name)}
          </ToggleButton>
        )
      })}
    </ToggleButtonGroup>
  )
}
